import { coerceBooleanProperty } from '@angular/cdk/coercion'
import { CommonModule } from '@angular/common'
import {
    Component,
    EventEmitter,
    HostBinding,
    Input,
    OnDestroy,
    Output,
    booleanAttribute,
    effect,
    input,
} from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { IconPosition } from '@shared-ui-lib/collapsible/collapsible.model'
import { Animations } from '@shared-util-lib/animations/animations'
import { BehaviorSubject, Subscription } from 'rxjs'

@Component({
    selector: 'app-collapsible',
    styleUrls: ['./collapsible.component.scss'],
    templateUrl: './collapsible.component.html',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    animations: [Animations.flipIcon],
})
export class CollapsibleComponent implements OnDestroy {
    @HostBinding('class.left') protected iconPositionLeft: boolean = false

    @HostBinding('class.right') protected iconPositionRight: boolean = false

    @HostBinding('class.small') protected isSmallSet: boolean = false

    @HostBinding('class.collapsed') protected isCollapsed: boolean = false

    protected title$ = new BehaviorSubject<string>('')
    @Input({ required: true })
    set title(title: string) {
        this.title$.next(title)
    }

    private iconPosition$ = new BehaviorSubject<IconPosition>('right')
    @Input()
    set iconPosition(iconPosition: IconPosition) {
        this.iconPosition$.next(iconPosition)
    }

    private small$ = new BehaviorSubject<boolean>(false)
    @Input()
    set small(value: boolean | undefined) {
        this.small$.next(coerceBooleanProperty(value))
    }

    openCollapsible = input(false, { transform: booleanAttribute })

    @Output() public readonly collapsed = new EventEmitter<boolean>()

    private subscriptions = new Subscription()

    protected collapsed$ = new BehaviorSubject<boolean>(true)

    constructor() {
        this.subscriptions.add(
            this.iconPosition$.subscribe((iconPosition) => {
                if (iconPosition === 'left') {
                    this.iconPositionLeft = true
                    this.iconPositionRight = false
                } else {
                    this.iconPositionLeft = false
                    this.iconPositionRight = true
                }
            })
        )

        this.subscriptions.add(
            this.small$.subscribe((isSmall) => {
                this.isSmallSet = isSmall
            })
        )

        this.subscriptions.add(
            this.collapsed$.subscribe((collapsed) => {
                this.isCollapsed = collapsed
            })
        )

        this.subscriptions.add(
            this.collapsed$.subscribe((isCollapsed) => {
                this.collapsed.emit(isCollapsed)
            })
        )

        // open collapsible from the outside, when not already open
        effect(() => {
            if (this.openCollapsible() && this.collapsed$.value) {
                this.collapsed$.next(!this.collapsed$.value)
            }
        })
    }

    onCollapsibleClick(event?: Event) {
        // if an link will be opened within collapsible,
        // then do not collapse it
        const eventTarget = event?.target
        if (eventTarget instanceof HTMLElement && eventTarget.tagName == 'A')
            return

        this.collapsed$.next(!this.collapsed$.value)
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }
}
